(function (upp) {
    'use strict';

    upp.controller('upp.loyalty.LoyaltyListCtrl', ['loyaltyService', 'appi', '$scope',
        function (loyaltyService, appi, $scope) {

            appi.ui.changeActualOption({moduleKey2Display: 'loyaltycard', navbarKey: 'loyaltycard'});
            appi.ui.showPageLoadingMsg();

            loyaltyService.getLoyaltiesList()
                .then(function (loyalties) {

                    loyalties.forEach(function(loyalty) {
                        var dateFrom = loyalty.validFrom.split(" ")[0].split("-");
                        var newParsedFrom = dateFrom[0]+"/"+dateFrom[1]+"/"+dateFrom[2];
                        loyalty.validFrom = new Date(newParsedFrom);
                        if (loyalty.validUntil == null){
                            loyalty.validUntil = null;
                        }
                        else {
                            var dateUntil = loyalty.validUntil.split(" ")[0].split("-");
                            var newParsedUntil = dateUntil[0]+"/"+dateUntil[1]+"/"+dateUntil[2];
                            loyalty.validUntil = new Date(newParsedUntil);
                        }
                        loyalty.numberStamps = (loyalty.numberStamps - 1) + " + 1";
                    });

                    $scope.loyalties = loyalties;

                    appi.ui.hidePageLoadingMsg();
                }, function () {
                    appi.ui.hidePageLoadingMsg();
                    appi.ui.showNetworkError();
                });

        }
    ]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/loyalty/controllers/loyalty-list-controllers.js